import React from "react";
import { Header, Message, Icon } from "semantic-ui-react";

import Layout from "components/layout";
import SEO from "components/seo";

import ui_quantizer from "images/func/quantizer.png";

const QuantizerPage = () => (
  <Layout docs="/docs/functions/quantizer">
    <SEO title="Docs" />

    <Header as="h1">Quantizer function</Header>

    <p>
      <svg viewBox="40 113 588 210" className="solid">
        <image href={ui_quantizer} />
      </svg>
    </p>

    <p>
      The <strong>quantizer</strong> is a demonstration of how limiting the
      number of bits in audio sounds like. It supports addition of dither which
      will lessen the noise generated by the quantization.
    </p>

    <p>
      The number of <strong>audio bits</strong> sets the quantization level. The
      incoming audio will be crushed down to be represented with the specified
      number of bits. Reduce this number to experience how fewer and fewer bits
      sound like.
    </p>

    <Message raised style={{ background: "#dddddd" }} icon>
      <Icon name="info" size="big" />
      <Message.Content>
        <Message.Header>Experiment:</Message.Header>
        Test your hearing skill by setting the number of bit high (20) and start
        playing back some audio. Slowly decrease the number of audio bits. When
        do you start to hear the quantization effects?
      </Message.Content>
    </Message>
  </Layout>
);

export default QuantizerPage;
